import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import { DataTestAttributes } from '../../constants/DataTestAttributes';
import { CouponContainer } from './styled';
import { useDispatch } from 'react-redux';
import { fireCouponCommand, callbackFromCoupon, getRioCouponDetails } from './helper';
import { Component, ContextType, Coupon, DropInPaymentsCommandNames, fireStatusUpdate, getRecurlyCart, getRecurlyPreviewPurchase, Namespace, SharedCommandNames, StatusTypes } from '@chegg/commerce-utils';
import { useAppSelector } from '../../hooks/useAppSelector';
import { configSelector } from '../../redux/config/config.selectors';
import { cartSelector } from '../../redux/cart/cart.selectors';
import { getClient } from '@chegg-web-tools/apollo-utils';
import { saveConfigs } from '../../redux/config/config.slice';
import { saveCartInfo } from '../../redux/cart/cart.slice';
import { savePaymentMethodsCommands } from '../../redux/command/command.slice';
var CouponWrapper = function CouponWrapper(_ref) {
  var productFamily = _ref.productFamily,
    cartId = _ref.cartId,
    onError = _ref.onError,
    content = _ref.content,
    totalWithCurrencyFormat = _ref.totalWithCurrencyFormat;
  var apolloClient = getClient();
  var dispatch = useDispatch();
  var _useAppSelector = useAppSelector(configSelector),
    isCouponVerified = _useAppSelector.isCouponVerified,
    rioNamespace = _useAppSelector.rioNamespace,
    coupon = _useAppSelector.coupon,
    couponCode = _useAppSelector.couponCode,
    countryCode = _useAppSelector.country,
    uuid = _useAppSelector.userUuid,
    isRecurly = _useAppSelector.isRecurly,
    recurlyCart = _useAppSelector.recurlyCart;
  var _useAppSelector2 = useAppSelector(cartSelector),
    orderSummary = _useAppSelector2.orderSummary,
    cartItems = _useAppSelector2.items,
    externalId = _useAppSelector2.externalId;
  var getRecurlyOrderSummary = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(couponCode) {
      var currency, _recurlyCart$orderSum, previewPurchase, _recurlyCart;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            currency = recurlyCart === null || recurlyCart === void 0 ? void 0 : recurlyCart.orderSummary.currencyName;
            if (!(externalId && uuid && currency)) {
              _context.next = 7;
              break;
            }
            _context.next = 4;
            return getRecurlyPreviewPurchase({
              externalId: externalId,
              currency: currency,
              uuid: uuid,
              apolloClient: apolloClient,
              couponCode: couponCode
            });
          case 4:
            previewPurchase = _context.sent;
            _recurlyCart = getRecurlyCart({
              previewPurchase: previewPurchase,
              cartItems: cartItems,
              externalId: externalId,
              currency: currency
            });
            return _context.abrupt("return", (_recurlyCart$orderSum = _recurlyCart === null || _recurlyCart === void 0 ? void 0 : _recurlyCart.orderSummary) !== null && _recurlyCart$orderSum !== void 0 ? _recurlyCart$orderSum : null);
          case 7:
            return _context.abrupt("return", null);
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getRecurlyOrderSummary(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleRecurlyAddCoupon = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(couponCode) {
      var orderSummary, total, subtotal, currencyName;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            dispatch(saveConfigs({
              couponCode: couponCode,
              coupon: {
                addCouponStatus: StatusTypes.PENDING,
                removeCouponStatus: '',
                totalWithCurrencyFormat: null
              }
            }));
            _context2.next = 3;
            return getRecurlyOrderSummary(couponCode);
          case 3:
            orderSummary = _context2.sent;
            if (orderSummary) {
              fireStatusUpdate([{
                status: StatusTypes.SUCCESS,
                command: DropInPaymentsCommandNames.ADD_COUPON,
                payload: {
                  component: Component.COMMAND_MANAGER,
                  context: ContextType.DROP_IN_PAYMENTS,
                  data: {
                    orderSummary: orderSummary,
                    couponCode: couponCode
                  }
                }
              }], Namespace.DROP_IN_PAYMENTS);
              dispatch(saveConfigs({
                couponCode: couponCode,
                coupon: {
                  addCouponStatus: StatusTypes.SUCCESS,
                  removeCouponStatus: '',
                  totalWithCurrencyFormat: orderSummary.totalWithCurrencyFormat
                }
              }));
              dispatch(saveCartInfo({
                orderSummary: orderSummary
              }));
              total = orderSummary.total, subtotal = orderSummary.subtotal, currencyName = orderSummary.currencyName;
              dispatch(savePaymentMethodsCommands([{
                commandName: SharedCommandNames.UPDATE_PRICING,
                data: {
                  total: total,
                  subtotal: subtotal,
                  currency: currencyName
                }
              }]));
            } else {
              dispatch(saveConfigs({
                coupon: {
                  addCouponStatus: StatusTypes.ERROR,
                  removeCouponStatus: '',
                  totalWithCurrencyFormat: ''
                }
              }));
            }
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleRecurlyAddCoupon(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleRecurlyRemoveCoupon = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var orderSummary, total, subtotal, currencyName;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return getRecurlyOrderSummary();
          case 2:
            orderSummary = _context3.sent;
            if (orderSummary) {
              fireStatusUpdate([{
                status: StatusTypes.SUCCESS,
                command: DropInPaymentsCommandNames.REMOVE_COUPON,
                payload: {
                  component: Component.COMMAND_MANAGER,
                  context: ContextType.DROP_IN_PAYMENTS,
                  data: {
                    orderSummary: orderSummary
                  }
                }
              }], Namespace.DROP_IN_PAYMENTS);
              dispatch(saveConfigs({
                coupon: {
                  addCouponStatus: '',
                  removeCouponStatus: StatusTypes.SUCCESS,
                  totalWithCurrencyFormat: orderSummary.totalWithCurrencyFormat
                },
                isCouponVerified: false,
                couponCode: ''
              }));
              total = orderSummary.total, subtotal = orderSummary.subtotal, currencyName = orderSummary.currencyName;
              dispatch(savePaymentMethodsCommands([{
                commandName: SharedCommandNames.UPDATE_PRICING,
                data: {
                  total: total,
                  subtotal: subtotal,
                  currency: currencyName
                }
              }]));
            }
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function handleRecurlyRemoveCoupon() {
      return _ref4.apply(this, arguments);
    };
  }();
  var addCouponStatus = coupon.addCouponStatus || '';
  var removeCouponStatus = coupon.removeCouponStatus || '';
  // Hack: To test coupon component locally. uncomment "couponContent" prop in index.html

  var rioCouponDetails = getRioCouponDetails(addCouponStatus, couponCode, orderSummary);
  return /*#__PURE__*/React.createElement(CouponContainer, {
    id: 'coupon-container',
    "data-test": DataTestAttributes.COUPON_WRAPPER
  }, /*#__PURE__*/React.createElement(Coupon, {
    isCouponValidated: isCouponVerified,
    couponCode: couponCode,
    isRecurly: isRecurly,
    addCoupon: function addCoupon(couponCode) {
      void (isRecurly ? handleRecurlyAddCoupon(couponCode) : fireCouponCommand({
        couponCode: couponCode,
        productFamily: productFamily,
        cartId: cartId,
        dispatch: dispatch,
        isCouponVerified: isCouponVerified,
        commandType: DropInPaymentsCommandNames.ADD_COUPON
      }));
    },
    removeCoupon: function removeCoupon(couponCode) {
      void (isRecurly ? handleRecurlyRemoveCoupon() : fireCouponCommand({
        couponCode: couponCode,
        productFamily: productFamily,
        cartId: cartId,
        dispatch: dispatch,
        isCouponVerified: isCouponVerified,
        commandType: DropInPaymentsCommandNames.REMOVE_COUPON
      }));
    },
    callback: callbackFromCoupon,
    productFamily: productFamily,
    onError: onError,
    addCouponStatus: addCouponStatus,
    removeCouponStatus: removeCouponStatus,
    content: content,
    namespace: rioNamespace,
    totalWithCurrencyFormat: totalWithCurrencyFormat,
    rioCouponDetails: rioCouponDetails,
    countryCode: countryCode
  }));
};
export default CouponWrapper;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/components/Coupon/index.js
// module id = 4657
// module chunks = 11